/**
 * The addresses of Design Language: the pages DesignLanguageShell wraps in
 * App.tsx, and where the Elevation chrome (header, body, theme) steps aside.
 *
 * Design Language is the team's internal design material (Proposal 09 § 8.2,
 * ~/Vault/_system/proposals/09-elevation-separation.md): the overview, its
 * references and component catalog, the icon customizer and table designer,
 * the 23 legacy pages and their Legacy page, the brand guidelines document,
 * and the three Lab tools Wes placed here (metaphor studio, visual-verbal
 * integration, geometry studio). The addresses did not change when it got its
 * own shell; they still start with /elevation.
 *
 * Each entry also covers the paths under it, on path-segment boundaries, read
 * the way the router reads them (lib/elevationAccess.ts routerPath).
 * designLanguageImports.test.ts checks this list against the routes in App.tsx.
 */
import { routerPath } from '../../lib/elevationAccess';

export const DESIGN_LANGUAGE_PATHS: readonly string[] = [
  // Current
  '/elevation/design-language',
  '/elevation/priorities-ai-design-language', // foundations, tokens, colors, type, logo, icons, skills, legacy
  '/elevation/design-system/components',
  '/elevation/icon-customizer',
  '/elevation/table-designer',
  // Old addresses of current pages (redirects)
  '/elevation/colors',
  '/elevation/typography',
  '/elevation/logo-system',
  '/elevation/favicon-app-icons',
  // Legacy, under the Legacy heading
  '/elevation/archive/design-language-legacy',
  '/elevation/brand-design-system',
  '/elevation/comprehensive-visual-identity-system',
  '/elevation/brand-elements',
  '/elevation/icon-library',
  '/elevation/component-library',
  '/elevation/layout-grid-system',
  '/elevation/motion-animation-principles',
  '/elevation/infographic-data-viz-standards',
  '/elevation/application-templates',
  '/elevation/accessibility-rules',
  '/elevation/patterns-background-elements',
  '/elevation/tone-voice-system',
  '/elevation/visual-design-grammar',
  '/elevation/visual-grammar-system',
  '/elevation/visual-verbal-integration',
  '/elevation/visual-inspiration-direction',
  '/elevation/best-practices-design-principles',
  // Placed in Design Language by Wes (Proposal 09 § 8.2)
  '/elevation/lab/brand-guidelines-document',
  '/elevation/lab/metaphor-studio',
  '/elevation/lab/visual-verbal-integration',
  '/elevation/lab/geometry-studio',
];

/** True for every Design Language page and the paths under each. */
export function isDesignLanguagePath(pathname: string): boolean {
  const path = routerPath(pathname);
  return DESIGN_LANGUAGE_PATHS.some((p) => path === p || path.startsWith(`${p}/`));
}
